"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ContentImage;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Image = _interopRequireDefault(require("../../atoms/Image"));

function ContentImage(_ref) {
  var width = _ref.width,
      imageProps = (0, _objectWithoutProperties2["default"])(_ref, ["width"]);
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], imageProps));
}

;
ContentImage.propTypes = {
  width: _propTypes["default"].string
};
ContentImage.defaultProps = {
  width: undefined
};